var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 21.5H5.36819C4.69506 21.5 4.3585 21.5 4.20265 21.3669C4.06742 21.2514 3.99566 21.0781 4.00961 20.9009C4.02569 20.6965 4.26368 20.4585 4.73965 19.9826L14.1874 10.5349C14.6274 10.0948 14.8474 9.87483 15.1011 9.7924C15.3243 9.71989 15.5646 9.71989 15.7878 9.7924C16.0415 9.87483 16.2615 10.0948 16.7015 10.5349L21 14.8333V16.1667M15.6667 21.5C17.5335 21.5 18.4669 21.5 19.18 21.1367C19.8072 20.8171 20.3171 20.3072 20.6367 19.68C21 18.9669 21 18.0335 21 16.1667M15.6667 21.5H6.33333C4.46649 21.5 3.53307 21.5 2.82003 21.1367C2.19282 20.8171 1.68289 20.3072 1.36331 19.68C1 18.9669 1 18.0335 1 16.1667V6.83333C1 4.96649 1 4.03307 1.36331 3.32003C1.68289 2.69282 2.19282 2.18289 2.82003 1.86331C3.53307 1.5 4.46649 1.5 6.33333 1.5H15.6667C17.5335 1.5 18.4669 1.5 19.18 1.86331C19.8072 2.18289 20.3171 2.69282 20.6367 3.32003C21 4.03307 21 4.96649 21 6.83333V16.1667M9.33333 7.61111C9.33333 8.83841 8.33841 9.83333 7.11111 9.83333C5.88381 9.83333 4.88889 8.83841 4.88889 7.61111C4.88889 6.38381 5.88381 5.38889 7.11111 5.38889C8.33841 5.38889 9.33333 6.38381 9.33333 7.61111Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.cb3b18bdcebd4fe13d0f3c80ee8c3c3b.svg";
export { ForwardRef as ReactComponent };